import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBranchSettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../../helpers';

export const useLegalClientBranchSettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBranchSettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (
      legalId: string,
      branchId: string,
      currentStepName: OnboardingProcessStepNameType
    ) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id: legalId,
          branchId,
          input,
        },
      });
      return res.data?.legalClientBranchSettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.legalClientBranchSettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveSettings,
  };
};
